import { Bank } from '@core/model/domain/bank';
import { OkVal } from '@core/model/framework/Result/OkResult';
import { Usecase } from '@core/model/framework/usecase';
import type { BankService } from '@core/model/service/bankService';
import { SERVICE_ID } from '@di/serviceId';
import { inject, injectable } from 'inversify';

export type GetBankByIdOutput = Promise<OkVal<Bank>>;
export type GetBankByIdInput = { bankId: string };

@injectable()
export class GetBankById implements Usecase<GetBankByIdInput, GetBankByIdOutput> {
  constructor(
    @inject(SERVICE_ID.bankService)
    private readonly bankService: BankService
  ) {}

  async execute(input: GetBankByIdInput): GetBankByIdOutput {
    const { bankId } = input;
    return this.bankService.getBankById({ bankId });
  }
}
